import styled from '@emotion/styled';
const Table = styled.ul `
  display: table;
  margin: 0;
  padding: 0;
`;
const TableRow = styled.li `
  display: table-row;
`;
const TableCell = styled.div `
  display: table-cell;
  padding: ${({ theme }) => theme.spacing[100]} 0;
`;
export { Table, TableCell, TableRow };
//# sourceMappingURL=styled.js.map